@for (item of visibleInfobars(); track item.uuid) {
  <ui-info-bar
    [uuid]="item.uuid"
    [message]="item.message"
    [showIconClose]="item.showIconClose"
    [showIconInfo]="item.showIconInfo"
    [theme]="item.theme"
    [data]="{
      id: item.id,
      name: item.name,
    }"
    (closed)="onInfobarClosed(item.uuid)">
  </ui-info-bar>
}
